import {Injectable, Injector} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {PlayerBaseService} from './player.base.service';
import {Log, LogTag} from '../Log';
import {Observable, of, switchMap} from "rxjs";
import {take} from "rxjs/operators";
import {lastMap} from "../../rxjs/lastMap";


@Injectable({
  providedIn: 'root'
})
export class PlayerWebService extends PlayerBaseService {
  constructor(protected  injector: Injector, /*???protected cookieService: CookieService, */protected route: ActivatedRoute) {
    super(injector);
  }

  getSceneId(): Observable<any> {
    return of(this.sceneId);
  }


  init(): Observable<any> {
    const logInfo = Log.getLogInfo("PlayerWebService", "init", []);
    return super.init().pipe(
      lastMap( r1 => this.route.queryParams ),
      take(1),
      switchMap(params => {
        Log.d(logInfo, LogTag.INIT, 'params=' + params);
        this.domain = params['domain'];
        this.businessId = params['businessId'];
        this.sceneId = params['sceneId'];
        this.webToken = params['token'];
        Log.devMode = params['dev'] == '1';
        return this.caching.init(false, false);
      }),
      switchMap(r=> this.updateCustomerInfo())
    );
  }



  getServiceUrl() {
    return 'https://' + this.businessDomain +
      '/Web/loadData.ashx?businessId=' + this.businessId +
      '&sceneId=' + this.sceneId;
  }


  checkForUpdates() {

  }


  createServerSocket(fnConnect: Function, fnData: Function, fnClose: Function) {

  }
}
